import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";
import type { Plan } from "@/hooks/use-plans";
import { FEATURE_NAMES, SYSTEM_FIELD_CONFIG } from "@/lib/plans/enforce";

interface TrackingPlanCardProps {
  plan: Plan;
  onSubscribe: () => void;
  onTrial: () => void;
}

export function TrackingPlanCard({ plan, onSubscribe, onTrial }: TrackingPlanCardProps) {
  const isPopular = plan.name?.toLowerCase().includes('professional') || plan.name?.toLowerCase().includes('pro');
  
  // Get features from plan
  const limits = plan.features?.limits || {};
  const toggles = plan.features?.toggles || {};
  
  // Get system configuration
  const systemConfig = SYSTEM_FIELD_CONFIG['gps_tracking'];
  
  return (
    <div className={`relative rounded-2xl p-6 ${
      isPopular 
        ? 'bg-gradient-to-b from-[#0d9488]/30 to-[#0f766e]/20 border-2 border-[#0d9488]' 
        : 'bg-white/5 border border-white/10'
    } backdrop-blur transition-all duration-300 hover:scale-105`}>
      {isPopular && (
        <Badge className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#a3e635] text-[#0b1220] font-semibold">
          Mais Popular
        </Badge>
      )}
      
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
        <p className="text-white/70 text-sm mb-4">{plan.description}</p>
        
        <div className="flex items-baseline justify-center gap-2 mb-2">
          <span className="text-4xl font-bold text-[#a3e635]">
            R$ {plan.price_monthly?.toFixed(2)}
          </span>
          <span className="text-white/60">/mês</span>
        </div>
        
        {plan.price_yearly && (
          <p className="text-sm text-white/60">
            ou R$ {plan.price_yearly.toFixed(2)}/ano
          </p>
        )}
      </div>

      <div className="space-y-2">
        <Button 
          className={`w-full ${
            isPopular 
              ? 'bg-[#a3e635] text-[#0b1220] hover:bg-[#a3e635]/90' 
              : 'bg-[#0d9488] text-white hover:bg-[#0f766e]'
          }`}
          onClick={onSubscribe}
        >
          Assinar Agora
        </Button>
        
        <Button 
          variant="outline" 
          className="w-full border-white/20 text-white hover:bg-white/5"
          onClick={onTrial}
        >
          Teste Grátis
        </Button>
      </div>
    </div>
  );
}
